"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zoomOut = void 0;
exports.zoomOut = {
    path: "M13.1292 11.8792H12.4709L12.2375 11.6542C13.0542 10.7042 13.5459 9.47083 13.5459 8.12916C13.5459 5.13749 11.1209 2.71249 8.12919 2.71249C5.13752 2.71249 2.71252 5.13749 2.71252 8.12916C2.71252 11.1208 5.13752 13.5458 8.12919 13.5458C9.47086 13.5458 10.7042 13.0542 11.6542 12.2375L11.8792 12.4708V13.1292L16.0459 17.2875L17.2875 16.0458L13.1292 11.8792ZM8.12919 11.8792C6.05419 11.8792 4.37919 10.2042 4.37919 8.12916C4.37919 6.05416 6.05419 4.37916 8.12919 4.37916C10.2042 4.37916 11.8792 6.05416 11.8792 8.12916C11.8792 10.2042 10.2042 11.8792 8.12919 11.8792ZM10.2125 7.71249H6.04586V8.54583H10.2125V7.71249Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
